import React from "react";

import {
    Typography,
    Button,
    FormControl,
    TextField
} from "@material-ui/core";
import { Modal, ModalHeader, ModalFooter, ModalBody } from "reactstrap";

export class AddFolderModal extends React.Component {
    render() {
        const {
            createFolder,
            folderName,
            createFolderModal,
            setName,
            setFolderSuccess,
            setFolderFail,
            setModalView
        } = this.props;

        return (
            <Modal isOpen={createFolderModal}>
                <ModalHeader>Create Folder</ModalHeader>
                <ModalBody>
                    <ModalInfoText text=" Create a new folder to store files in" />

                    <FormControl>
                        <TextField
                            onChange={event => {
                                setName(event.target.value);
                            }}
                            style={{ minWidth: 225 }}
                            value={folderName || ""}
                            label="Folder Name"
                        />
                    </FormControl>
                </ModalBody>
                <ModalFooter>
                    <Button
                        onClick={() => {
                            setModalView(false);
                        }}
                        variant="contained"
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={() => {
                            createFolder(folderName, success => {
                                if (success) {
                                    setFolderSuccess(true);
                                } else {
                                    setFolderFail(true);
                                }
                                setModalView(false);
                            });
                        }}
                        color="primary"
                        variant="contained"
                    >
                        Create Folder
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
}
const ModalInfoText = props => {
    return (
        <Typography variant="subheading" style={{ marginBottom: 15 }}>
            {props.text}
        </Typography>
    );
};
